var urlServer = 'https://api-tickets.trixlog.com';

var baseUrl = urlServer + '/tickets';

export default {
  baseUrl
}



// WEBPACK FOOTER //
// ./src/resources/Url.js